import { FEATURE_FLAG_KEYS, SHOP_THEME_NAME } from 'shop-ui/constants';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { createLogo } from 'app/shop-ui/component/Logo';
import { createSearchBar } from 'shop-ui/component/SearchBar';
import { createMenu } from 'shop-ui/component/Menu';
import { createHeaderCartIcon } from 'app/shop-ui/component/HeaderCartIcon';
import { createHeaderLoginIcon } from 'app/shop-ui/component/HeaderLoginIcon';
import i18n from '@shared/i18n';

export enum HEADER_LAYOUT_TYPE {
    STYLE_1 = 'header-layout-style-1',
    STYLE_2 = 'header-layout-style-2',
    STYLE_3 = 'header-layout-style-3',
    STYLE_4 = 'header-layout-style-4',
}

export const headerLayoutTypeMap = {
    [SHOP_THEME_NAME.STORY]: HEADER_LAYOUT_TYPE.STYLE_3,
    [SHOP_THEME_NAME.WINDOW]: HEADER_LAYOUT_TYPE.STYLE_1,
    [SHOP_THEME_NAME.PORTAL]: HEADER_LAYOUT_TYPE.STYLE_4,
    [SHOP_THEME_NAME.MAGAZINE]: HEADER_LAYOUT_TYPE.STYLE_4,
};

export function createHeader(theme: SHOP_THEME_NAME = SHOP_THEME_NAME.STORY) {
    const headerLayoutType = headerLayoutTypeMap[theme];

    const isWhiteLogo = theme === SHOP_THEME_NAME.PORTAL;

    const logo = createLogo({
        ...(isWhiteLogo && {
            [FEATURE_FLAG_KEYS.READONLY_DEFAULT_IMAGE_URL]:
                '/static/page-editor-logo-component-default-white_v1.png',
        }),
    });

    const headerSearchBar = createSearchBar(
        {
            deletable: false,
        },
        theme === SHOP_THEME_NAME.PORTAL
            ? {
                  [FEATURE_FLAG_KEYS.SEARCH_BOX_BACKGROUND_COLOR]:
                      'rgba(238, 238, 239, 1)',
                  [FEATURE_FLAG_KEYS.FONT_COLOR]: 'rgba(124, 124, 128, 1)',
                  [FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_COLOR]: 'rgba(255, 255, 255, 1)',
                  [FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_BACKGROUND_COLOR]: '',
              }
            : {}
    );

    let menuAlignment = 'right' as 'center' | 'right' | 'left';

    if (theme === SHOP_THEME_NAME.PORTAL || theme === SHOP_THEME_NAME.MAGAZINE) {
        menuAlignment = 'center';
    }

    if (theme === SHOP_THEME_NAME.STORY) {
        menuAlignment = 'left';
    }

    const headerNav = createMenu(
        {
            deletable: false,
        },
        {
            // @ts-ignore
            [FEATURE_FLAG_KEYS.RESPONSIVE_MENU_ENABLED]: true,
            [FEATURE_FLAG_KEYS.MENU_ALIGNMENT]: menuAlignment,
            [FEATURE_FLAG_KEYS.FONT_COLOR]:
                theme === SHOP_THEME_NAME.PORTAL
                    ? 'rgba(255, 255, 255, 1)'
                    : 'rgba(57, 57, 62, 1)',
        }
    );

    const headerCartIcon = createHeaderCartIcon({
        [FEATURE_FLAG_KEYS.COLOR]:
            theme === SHOP_THEME_NAME.PORTAL
                ? 'rgba(255, 255, 255, 1)'
                : 'rgba(57, 57, 62, 1)',
    });

    const headerLoginIcon = createHeaderLoginIcon({
        [FEATURE_FLAG_KEYS.COLOR]:
            theme === SHOP_THEME_NAME.PORTAL
                ? 'rgba(255, 255, 255, 1)'
                : 'rgba(57, 57, 62, 1)',
    });

    return combineComponent(
        i18n.gettext('頁首'),
        [[logo, headerSearchBar, headerNav, headerLoginIcon, headerCartIcon]],
        {
            primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
            secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
            primaryGridPresetStyle: {
                [FEATURE_FLAG_KEYS.HEADER_LAYOUT]: headerLayoutType,
                [FEATURE_FLAG_KEYS.MIN_HEIGHT]: '10px',
                [FEATURE_FLAG_KEYS.BACKGROUND_COLOR]:
                    theme === SHOP_THEME_NAME.PORTAL
                        ? 'rgba(57, 57, 62, 1)'
                        : 'rgba(255, 255, 255, 1)',
                [FEATURE_FLAG_KEYS.GRID_GAP]: '18px',
                [FEATURE_FLAG_KEYS.FIXED_SCREEN_HEIGHT]: false,
                [FEATURE_FLAG_KEYS.PADDING_TOP]: '25px',
                [FEATURE_FLAG_KEYS.PADDING_BOTTOM]: '25px',
                [FEATURE_FLAG_KEYS.PADDING_LEFT]: '27px',
                [FEATURE_FLAG_KEYS.PADDING_RIGHT]: '27px',
            },
            secondaryGridPresetStyle: [
                {
                    [FEATURE_FLAG_KEYS.GRID_ALIGNMENT]: 'center',
                    [FEATURE_FLAG_KEYS.GRID_GAP]: '18px',
                    [FEATURE_FLAG_KEYS.GRID_COLUMN_1]: '0.4fr',
                    [FEATURE_FLAG_KEYS.GRID_COLUMN_2]: '0.6fr',
                },
            ],
            shouldWrap: true,
            deletable: false,
        }
    );
}
